// extracted by mini-css-extract-plugin
export default {"bubble":"HomeBubble_bubble__0md2k","iconWhite":"HomeBubble_iconWhite__T0IiJ","iconBlack":"HomeBubble_iconBlack__74PkU"};